(function() {
  function ensureDrawerNode() {
    var drawer = document.querySelector('[data-drawer]');
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.setAttribute('data-drawer', '');
    drawer.style.display = 'none';
    document.body.appendChild(drawer);
    return drawer;
  }
  if (document.body) ensureDrawerNode();
  else document.addEventListener('DOMContentLoaded', ensureDrawerNode, { once: true });
  document.addEventListener('click', function(e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-drawer-toggle]') : null;
    if (!btn) return;
    ensureDrawerNode();
  }, true);
})();

/**
 * HC Variants
 * - Works for PDP + dynamically injected Quick View
 * - Fixes "not clickable" by (1) scoping selectors to the correct form/modal and (2) re-initializing on quick view open / DOM injection
 */
(function() {
  function getScope(variantsWrapper, root) {
    return (
      (variantsWrapper && variantsWrapper.closest && variantsWrapper.closest('.product-quick-add__content')) ||
      (variantsWrapper && variantsWrapper.closest && variantsWrapper.closest('[data-quick-add-modal]')) ||
      (variantsWrapper && variantsWrapper.closest && variantsWrapper.closest('product-info')) ||
      (variantsWrapper && variantsWrapper.closest && variantsWrapper.closest('form')) ||
      root ||
      document
    );
  }

  function inQuickView(variantsWrapper) {
    if (!variantsWrapper || !variantsWrapper.closest) return false;
    return !!(variantsWrapper.closest('[data-quick-add-modal]') || variantsWrapper.closest('.product-quick-add__content'));
  }

  function clickAttributeButtons(defaultString, scope) {
    if (!defaultString) return;
    var parts = defaultString.split('/').map(function(s) { return s.trim(); });

    parts.forEach(function(val) {
      if (!val) return;
      var safe = (window.CSS && CSS.escape) ? CSS.escape(val) : val.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      var target = '.hc-option-button[data-value="' + safe + '"]';
      var btn = (scope && scope.querySelector) ? scope.querySelector(target) : null;
      if (!btn) btn = document.querySelector(target);
      if (btn) btn.click();
    });
  }

  function initHcVariants(root) {
    root = root || document;

    // Collection description toggle (kept from your original file)
    // (bind once)
    var collectionDescription = document.querySelector('.collection-hero__description');
    var colDesFulTrigger = document.querySelector('.collection-hero__description .trigger-full--description');
    if (collectionDescription && colDesFulTrigger && !colDesFulTrigger.dataset.hcBound) {
      colDesFulTrigger.dataset.hcBound = '1';
      colDesFulTrigger.addEventListener('click', function() {
        collectionDescription.classList.toggle('show-full-description');
      });
    }

    var wrappers = root.querySelectorAll ? root.querySelectorAll('.hc-variants-outer') : [];
    if (!wrappers || !wrappers.length) return;

    wrappers.forEach(function(variantsWrapper) {
      if (!variantsWrapper) return;

      // prevent duplicate binding if init runs again
      if (variantsWrapper.dataset.hcVariantsInit === '1') return;
      variantsWrapper.dataset.hcVariantsInit = '1';

      var scope = getScope(variantsWrapper, root);

      var hcVariants = Array.prototype.slice.call(variantsWrapper.querySelectorAll('.hc-variant'));
      if (!hcVariants.length) return;

      var addToCartBtn =
        (scope && scope.querySelector ? scope.querySelector('[data-add-to-cart]') : null) ||
        (scope && scope.querySelector ? scope.querySelector('.hc-add-to-cart') : null) ||
        document.querySelector('[data-add-to-cart]') ||
        document.querySelector('.hc-add-to-cart');

      var addToCartText = addToCartBtn
        ? (addToCartBtn.querySelector('[data-add-to-cart-text]') || addToCartBtn.querySelector('.btn__text'))
        : null;

      var hiddenVariantInput =
        (scope && scope.querySelector ? scope.querySelector('.hc-variant-id') : null) ||
        (scope && scope.querySelector ? scope.querySelector('form.product-form input[name="id"]') : null) ||
        (scope && scope.querySelector ? scope.querySelector('input[name="id"]') : null) ||
        document.querySelector('.hc-variant-id') ||
        document.querySelector('form.product-form input[name="id"]') ||
        document.querySelector('input[name="id"]');

      var selectedTitleEl =
        (scope && scope.querySelector ? scope.querySelector('.hc-variant-selected .radio__legend__value') : null) ||
        document.querySelector('.hc-variant-selected .radio__legend__value');

      var atcTextDefault = '';
      var soldOutTextDefault = '';
      var unavailableTextDefault = '';
      var preorderTextDefault = '';

      if (addToCartBtn) {
        atcTextDefault = (addToCartBtn.getAttribute('data-atc-text') || addToCartBtn.getAttribute('data-add-text') || '').trim();
        soldOutTextDefault = (addToCartBtn.getAttribute('data-soldout-text') || addToCartBtn.getAttribute('data-sold-out-text') || '').trim();
        unavailableTextDefault = (addToCartBtn.getAttribute('data-unavailable-text') || '').trim();
        preorderTextDefault = (addToCartBtn.getAttribute('data-preorder-text') || '').trim();
        if (!atcTextDefault && addToCartText) atcTextDefault = (addToCartText.textContent || '').trim();
        if (!soldOutTextDefault) soldOutTextDefault = 'Sold Out';
        if (!unavailableTextDefault) unavailableTextDefault = soldOutTextDefault;
        if (!preorderTextDefault) preorderTextDefault = atcTextDefault || 'Add to cart';
      }

      function setAtcState(soldOut) {
        if (!addToCartBtn || !addToCartText) return;

        var isPreorder = addToCartBtn.getAttribute('data-preorder') === 'true';

        if (soldOut) {
          addToCartText.textContent = soldOutTextDefault;
          addToCartBtn.setAttribute('disabled', '');
        } else {
          addToCartText.textContent = isPreorder ? preorderTextDefault : (atcTextDefault || preorderTextDefault);
          addToCartBtn.removeAttribute('disabled');
        }
      }

      function syncShopifyForm(variantId) {
        if (!hiddenVariantInput) return;

        hiddenVariantInput.value = variantId;
        hiddenVariantInput.dispatchEvent(new Event('change', { bubbles: true }));

        // Do not change the page URL when selecting variants inside quick view
        if (inQuickView(variantsWrapper)) return;

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState(null, '', url.toString());
        } catch (e) {}
      }

      function applyVariant(el) {
        if (!el) return;

        hcVariants.forEach(function(v) { v.classList.remove('hc-variant-active'); });
        el.classList.add('hc-variant-active');

        var soldOut = el.classList.contains('hc-soldout');
        setAtcState(soldOut);

        var vid = el.getAttribute('data-variant');
        if (vid && hiddenVariantInput) syncShopifyForm(vid);

        var vtitle = el.getAttribute('data-variant-name');
        if (vtitle && selectedTitleEl) selectedTitleEl.textContent = vtitle;

        var defaults = el.getAttribute('data-variant-default');
        clickAttributeButtons(defaults, scope);
      }

      // Initialize ATC state based on the first active variant in THIS wrapper
      if (addToCartBtn && addToCartText) {
        var firstActive = variantsWrapper.querySelector('.hc-variant.hc-variant-active') || hcVariants[0];
        if (firstActive) setAtcState(firstActive.classList.contains('hc-soldout'));
      }

      // Click on variant (covers clicking .hc-value-wrapper too)
      hcVariants.forEach(function(hcVariant) {
        hcVariant.addEventListener('click', function() {
          applyVariant(this);
        });
      });

      // Keep your original radio delegation
      variantsWrapper.addEventListener('click', function(e) {
        var radioBtn = e.target && e.target.closest ? e.target.closest('.radio__button') : null;
        if (!radioBtn) return;
        var v = radioBtn.closest('.hc-variant');
        if (!v) return;
        applyVariant(v);
      }, true);

      var initial = variantsWrapper.querySelector('.hc-variant.hc-variant-active') || hcVariants[0];
      if (initial) applyVariant(initial);
    });
  }

  // PDP init
  document.addEventListener('DOMContentLoaded', function() {
    initHcVariants(document);
  });

  // Quick view open (theme event)
  document.addEventListener('theme:quick-add:open', function() {
    var openModal =
      document.querySelector('[data-quick-add-modal][open]') ||
      document.querySelector('[data-quick-add-modal]') ||
      document;
    initHcVariants(openModal);
  });

  // Fallback for dynamically inserted quick view content if event isn't fired
  (function() {
    if (!window.MutationObserver) return;

    function start() {
      if (!document.body) return;

      var obs = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (!m.addedNodes || !m.addedNodes.length) continue;

          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (!node || node.nodeType !== 1) continue;

            if (node.matches && node.matches('.hc-variants-outer')) {
              initHcVariants(node);
              continue;
            }

            if (node.querySelector && node.querySelector('.hc-variants-outer')) {
              initHcVariants(node);
            }
          }
        }
      });

      obs.observe(document.body, { childList: true, subtree: true });
    }

    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start, { once: true });
  })();

  // Expose for debugging if you want (optional)
  window.initHcVariants = initHcVariants;
})();

function hcOpenAndScrollToReviews() {
  var reviewsSection = document.querySelector(".accordion-section[data-section-type='faq']");
  if (!reviewsSection) return false;

  // Open the accordion
  var collapsibleEl = reviewsSection.querySelector('collapsible-elements');
  var detailsEl = reviewsSection.querySelector('[data-collapsible]');
  if (detailsEl) {
    if (collapsibleEl && typeof collapsibleEl.open === 'function') {
      collapsibleEl.open(detailsEl);
    }
    detailsEl.setAttribute('open', 'true');
    var body = detailsEl.querySelector('[data-collapsible-body]');
    if (body) body.style.height = 'auto';
  }

  var offset = 110;
  if (window.innerWidth <= 749) offset = 80;

  var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var elementPosition = reviewsSection.getBoundingClientRect().top + scrollY;
  var offsetPosition = Math.max(0, elementPosition - offset);

  requestAnimationFrame(function() {
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  });
  return true;
}

// Trigger on Judge.me review source URL param
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.indexOf('judgeme_review_source') !== -1) {
    hcOpenAndScrollToReviews();
  }
});

// Trigger on clicking the Judge.me preview badge
// Capture phase fires before Judge.me's own handlers; stopPropagation prevents them from running
document.addEventListener('click', function(e) {
  if (!e.target || !e.target.closest) return;
  var trigger = e.target.closest('.jdgm-preview-badge--with-link');
  if (!trigger) return;
  if (!document.querySelector(".accordion-section[data-section-type='faq']")) return;
  e.preventDefault();
  e.stopPropagation();
  hcOpenAndScrollToReviews();
}, true);
